import React, { ReactNode, useEffect, useState } from 'react'

import { useLocation, Redirect } from 'react-router-dom'

import { useMarker } from 'src/context/Marker'
import { skuit } from 'src/services/skuit'
import useProfileContext from 'src/context/ProfileContext'

interface Props {
  children: ReactNode
  logout?: boolean
  masked?: boolean
  staff?: boolean
}

export const AccessRequired = (props: Props) => {
  const { children, logout = true, masked = false, staff = false } = props
  const [, refresh] = useState({})
  const profileContext = useProfileContext()
  const location = useLocation()
  const { setReporter } = useMarker()
  useEffect(() => {
    const deauth = () => {
      setReporter(null)
      profileContext.unsetProfile()
      refresh({})
    }
    skuit.auth.registerCallback(deauth)
    return () => {
      skuit.auth.unregisterCallback(deauth)
    }
  }, [setReporter, profileContext])

  const response = logout ? <Redirect to="/auth/logout" /> : null

  if (!skuit.auth.isAuthed()) {
    return <Redirect to={`/auth/login?redirect=${location.pathname}`} />
  }

  if (staff && !skuit.auth.isStaff()) {
    return response
  }

  if (masked && !skuit.auth.isMasked()) {
    return response
  }

  return <>{children}</>
}
